import Image from 'next/image'

import { FloorType } from '../types'

type TopSectionBlockMobileProps = {
  topSectionData: FloorType['top_section']
}

const TopSectionBlockMobile = ({ topSectionData }: TopSectionBlockMobileProps) => {
  if (!topSectionData) return

  return (
    <div className="w-full bg-white px-0 pb-[48px] pt-0">
      <div className="flex flex-col items-start justify-between gap-[26px]">
        <div className="relative w-full max-w-[300px]">
          <Image
            src={topSectionData?.image || '/placeholder.svg'}
            alt="top-section"
            className="h-auto max-h-[26px] w-auto max-w-full object-contain object-left"
            style={{ height: 'auto' }}
            width={0}
            height={0}
            unoptimized
            sizes="100vw"
          />
        </div>

        <div className="ml-[2px] flex w-full gap-[4px]">
          {topSectionData?.items.map((item, index) => (
            <div
              key={`${index}-${item.title}-${item.subtitle}`}
              className={`flex flex-col items-start gap-[5px] rounded-lg bg-[#F8F8F9] px-[12px] py-[13px] ${
                topSectionData?.items.length === 1
                  ? 'w-full'
                  : topSectionData?.items.length === 2
                    ? 'w-[calc(50%-2px)]'
                    : 'w-[calc(33.333%-3px)]'
              }`}>
              <span className="font-miSansDemiBold450 text-base">{item.title}</span>
              <span className="max-w-[250px] font-miSansRegular330 text-sm text-[#6E6E73]">
                {item.subtitle}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TopSectionBlockMobile
